import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router'
import { type Route } from './+types/route'
import { GeneralErrorBoundary } from '~/components/error-boundary.tsx'
import { Icon, type IconName } from '~/components/icon'
import { Layout } from '~/components/layout.tsx'
import {
  ButtonStyle,
  ButtonType,
  Align,
} from '~/domains/navbar-settings/types.ts'
import { api } from '~/utils/gql-client.server.ts'

export async function loader({ params }: Route.LoaderArgs) {
  const { blogCategories } = await api.BlogCategories()
  const slug = params.slug

  return {
    blogCategories,
    slug,
  }
}

export default function Blog({
  loaderData: { blogCategories, slug },
}: Route.ComponentProps) {
  const navbarSettings = {
    fixed: true,
    transparent: false,
    showLanguageSelector: false,
    showSearch: true,
    align: Align.Center,
    logo: {
      name: 'rouvy-blog-logo' as IconName,
      title: 'Rouvy Blog',
      link: 'https://rouvy.com/blog',
      className: 'h-[16px] w-[165px]',
    },
    navLinks: blogCategories.map((category) => ({
      title: category.title,
      url: `/blog/category/${category.slug}`,
      active: slug === category.slug,
    })),
    buttons: [
      {
        text: 'rouvy.com',
        link: 'https://rouvy.com',
        buttonStyle: ButtonStyle.Secondary,
        buttonType: ButtonType.Default,
        icon: <Icon name="open-in" size="md" />,
        external: true,
      },
    ],
  }

  return (
    <Layout navbarSettings={navbarSettings}>
      <Outlet />
    </Layout>
  )
}

export function ErrorBoundary() {
  const { t } = useTranslation(['blog'])
  return (
    <GeneralErrorBoundary
      unexpectedErrorHandler={() => (
        <p className="text-body-20 font-semibold text-text-muted">
          {t('blog_not_loaded')}
        </p>
      )}
    />
  )
}
